import ActivityHeaderSkeleton from "@/modules/lead-page/new/components/activity/activity-header-skeleton";
import ActivityFilters from "@/modules/lead-page/new/components/activity/filters/activity-filters";
import useActivityTimeline from "@/modules/lead-page/new/hooks/activity-timline.hook";
import SectionHeader from "@/modules/lead-page/new/components/common/section-header";

interface ActivityHeaderProps {
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

const ActivityHeader = ({ onToggleCollapse }: ActivityHeaderProps) => {
  const { isLoading, isFetching, isError, count, isEmpty } =
    useActivityTimeline();

  return isLoading || isFetching ? (
    <ActivityHeaderSkeleton />
  ) : (
    <SectionHeader
      title="Activity"
      count={isEmpty || isError ? 0 : count}
      countLabel="logs"
      rightElement={<ActivityFilters onToggleCollapse={onToggleCollapse} />}
    />
  );
};

export default ActivityHeader;
